module.exports = __webpack_public_path__ + "static/img/pic-zhou1.fbc2fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-zhou1.jpg
// module id = 933
// module chunks = 0